/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react"
import { T支払先区分 } from "../../constant/enum/master"
import { defaultComboBoxTextFormatter } from "../../ts/util/commonUtil"
import BaseComboBox, { TExtendedBaseComboBoxProps } from "./BaseComboBox"

//TODO:ダミー用に配置
export type T支払先 = {
  支払先ID: number
  支払先コード: string
  支払先名: string
  支払先略称: string
  支払先区分コード: string
  郵便番号: string
  住所１: string
  住所２: string
  住所３: string
  電話番号: string
  FAX番号: string
  支払先担当者: string
}

// コンボボックスでの表示対象となるアイテムの型定義をここに記載
type TItem = T支払先 & { name?: string }

const displayNameProperty: keyof TItem = "name"
// コンボボックスの表示名とするプロパティ名
const displayField: keyof TItem = "支払先名"
// 表示名のデフォルトフォーマッタ
const defaultDisplayTextFormatter = defaultComboBoxTextFormatter

// コンボボックスの選択値となるプロパティ名
const valueField: keyof TItem = "支払先コード"

// 全選択の選択用アイテム生成処理
const createAllSelectItem = () => {
  const obj = {} as TItem
  // 全選択の表示名
  obj[displayField] = `すべて`
  // 全選択時の値
  obj[valueField] = ""
  return obj
}

// 未選択用のアイテム生成処理
const createEmptyItem = () => {
  const obj = {} as TItem
  // 全選択の表示名
  obj[displayField] = ``
  // 全選択時の値
  obj[valueField] = ""
  return obj
}

/**
 *
 * @param props
 * @returns
 */
export const SiharaiSakiComboBox: React.FC<
  TExtendedBaseComboBoxProps<string, T支払先> & {
    siharaiSaki?: T支払先区分 | T支払先区分[]
  }
> = (props) => {
  // state
  const [innerItemsSource, setInnerItemsSource] = useState<Array<TItem>>([])

  // nameプロパティ追加処理
  const appendNameProperty = (data: TItem[]) => {
    // any型で処理することで name プロパティを追加
    data.forEach((value: TItem) => {
      value[displayNameProperty] = props.displayTextFormatter
        ? props.displayTextFormatter(value)
        : defaultDisplayTextFormatter(value, valueField, displayField)
    })
  }

  // 初期値がある場合の設定処理
  const setDefaultValue = (data: TItem[]) => {
    if (props.defaultValue) {
      const firstData = data.find((d) => {
        return d[valueField] === props.defaultValue
      })
      if (firstData != null) {
        props.setText && props.setText(firstData[displayNameProperty] ?? "")
        props.setSelectedItem && props.setSelectedItem(firstData)
        props.setSelectedValue && props.setSelectedValue(firstData[valueField])
      }
    }
  }
  // itemsSource更新時に選択Itemを先頭のitemに変更
  const setFirstValue = (data: TItem[]) => {
    if (data.length > 0) {
      // 既存の選択値が既にいた場合、選択を変えない
      const selectedData = data.find(
        (d) => d[valueField] === props.selectedValue
      )
      if (selectedData != null) {
        props.setText && props.setText(selectedData[displayNameProperty] ?? "")
        props.setSelectedItem && props.setSelectedItem(selectedData)
        props.setSelectedValue &&
          props.setSelectedValue(selectedData[valueField])
        return
      }
      // いない場合初期値を選択
      const firstData = data[0]
      if (firstData != null) {
        props.setText && props.setText(firstData[displayNameProperty] ?? "")
        props.setSelectedItem && props.setSelectedItem(firstData)
        props.setSelectedValue && props.setSelectedValue(firstData[valueField])
      }
    }
  }
  // 支払先フィルター用
  const siharaiSakiFilter = (item: T支払先) => {
    if (props.siharaiSaki == null) return true

    if (Array.isArray(props.siharaiSaki)) {
      return props.siharaiSaki.find((code) => code === item.支払先区分コード)
    } else {
      return props.siharaiSaki === item.支払先区分コード
    }
  }
  // 初期設定
  useEffect(() => {
    // itemsSource検索開始フラグ
    if (
      props.itemsSource != null &&
      props.ComboBox != null &&
      props.isLoadEnded === false
    ) {
      // 支払先区分が設定されていた場合、そちらで先にフィルターする
      const data = (props.itemsSource ?? [])
        .filter(siharaiSakiFilter)
        .filter(props.listFilter ? props.listFilter : () => true)
      if (props.isAllSelect) {
        data.splice(0, 0, createAllSelectItem())
      } else if (props.isEmpty) {
        data.splice(0, 0, createEmptyItem())
      }

      // デフォルトラベルを設定
      appendNameProperty(data)
      setInnerItemsSource(data)
      setDefaultValue(data)

      props.setIsLoadEnded(true)
    }
  }, [props.itemsSource, props.ComboBox, props.isLoadEnded])

  // itemsSource更新時
  useEffect(() => {
    if (
      props.itemsSource != null &&
      props.ComboBox != null &&
      props.isLoadEnded
    ) {
      // 支払先区分が設定されていた場合、そちらで先にフィルターする
      const data = (props.itemsSource ?? [])
        .filter(siharaiSakiFilter)
        .filter(props.listFilter ? props.listFilter : () => true)
      if (props.isAllSelect) {
        data.splice(0, 0, createAllSelectItem())
      } else if (props.isEmpty) {
        data.splice(0, 0, createEmptyItem())
      }

      appendNameProperty(data)
      setInnerItemsSource(data)
      // データを更新
      setFirstValue(data)
    }
  }, [props.itemsSource])

  // 必要項目を渡したBaseComboBoxを返却
  return (
    <>
      <BaseComboBox
        displayField={displayNameProperty}
        valueField={valueField}
        {...props}
        itemsSource={innerItemsSource}></BaseComboBox>
    </>
  )
}
